export default {
  id: "passport",
  en: {
    title: "Публичный блокчейн паспорт",
    subtitle1: "Информация об отправителе",
    subtitle2: "Собранная информация",
    subtitle3: "Заказ блокчейн паспорта",
    priceTitle: "Стоимость блокчейн паспорта составит",
    details: "Показать больше деталей",
    detailsLess: "Показать меньше деталей",
    success: "Ваш блокчейн паспорт",
    link: "Перейти на страницу блокчейн паспорта",
    agent: "Агент",
    objective: "Задача",
    token: "Токен",
    requestPrice: "Запросить услугу",
    liability: "Контракт обязательства",
    info: "Дополнительная информация",
    meta: "Файл с информацией",
    images: "Фотографии",
    email: "E-mail",
    order: "Заказать блокчейн паспорт",
    error: "Проверьте пожалуйста правильность данных.",
    informations: "Дополнительная информация",
    metaField: "Прикрепите файл с информацией (json)",
    imagesField: "Прикрепите фотографии, если есть (jpg, png)",
    emailField: "E-mail",
    dragFile: "Drag & Drop your file or Browse",
    dragImages: "Drag & Drop your image files or Browse",
    view: "просмотр",
    viewImages: "показать фото",
    hideImages: "скрыть фото",
    loading: "Загрузка",
    openIpfs: "Открыть в IPFS",
    reqApprove:
      "Вам нужно одобрить дополнительную сумму для покупки блокчейн паспорта",
  },
  ru: {
    title: "Публичный блокчейн паспорт",
    subtitle1: "Информация об отправителе",
    subtitle2: "Собранная информация",
    subtitle3: "Заказ блокчейн паспорта",
    priceTitle: "Стоимость блокчейн паспорта составит",
    details: "Показать больше деталей",
    detailsLess: "Показать меньше деталей",
    success: "Ваш блокчейн паспорт",
    link: "Перейти на страницу блокчейн паспорта",
    agent: "Агент",
    objective: "Задача",
    token: "Токен",
    requestPrice: "Запросить услугу",
    liability: "Контракт обязательства",
    info: "Дополнительная информация",
    meta: "Файл с информацией",
    images: "Фотографии",
    email: "E-mail",
    order: "Заказать блокчейн паспорт",
    error: "Проверьте пожалуйста правильность данных.",
    informations: "Дополнительная информация",
    metaField: "Прикрепите файл с информацией (json)",
    imagesField: "Прикрепите фотографии, если есть (jpg, png)",
    emailField: "E-mail",
    dragFile: "Drag & Drop your file or Browse",
    dragImages: "Drag & Drop your image files or Browse",
    view: "просмотр",
    viewImages: "показать фото",
    hideImages: "скрыть фото",
    loading: "Загрузка",
    openIpfs: "Открыть в IPFS",
    reqApprove:
      "Вам нужно одобрить дополнительную сумму для покупки блокчейн паспорта",
  },
};
